import { useEffect, useState } from 'react';

const KEY = 'sm_compare_v1';
const EVENT = 'sm-compare-change';
export const COMPARE_MAX = 4;

const read = () => {
  try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
};
const write = (list) => {
  localStorage.setItem(KEY, JSON.stringify(list));
  window.dispatchEvent(new Event(EVENT));
};

export const useCompare = () => {
  const [list, setList] = useState(read);
  useEffect(() => {
    const sync = () => setList(read());
    window.addEventListener(EVENT, sync);
    window.addEventListener('storage', sync);
    return () => { window.removeEventListener(EVENT, sync); window.removeEventListener('storage', sync); };
  }, []);

  const has = (slug) => list.some((p) => p.slug === slug);
  const toggle = (item) => {
    if (has(item.slug)) { write(list.filter((p) => p.slug !== item.slug)); return true; }
    if (list.length >= COMPARE_MAX) return false;
    write([...list, { slug: item.slug, name: item.name, description: item.description }]);
    return true;
  };
  const remove = (slug) => write(list.filter((p) => p.slug !== slug));
  const clear = () => write([]);
  return { list, has, toggle, remove, clear };
};
